
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Dictionary } from 'vue-router/types/router';
import { Form as ElForm, Input } from 'element-ui';
import { UserModule } from '@/store/modules/user';
// import { isValidUsername } from '@/utils/validate';
import { login, getCaptcha } from '@/api/users';
import { log } from 'util';

@Component({
  name: 'Login',
})
export default class extends Vue {
  private url = '';
  private tid = '';

  private loginForm = {
    username: '',
    password: '',
    captcha: '',
    tid: '',
  };

  private passwordType = 'password';
  private loading = false;
  private showDialog = false;
  private redirect?: string;
  private otherQuery: Dictionary<string> = {};

  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!value.length) {
      callback(new Error('请输入用户名'));
    } else {
      callback();
    }
  };

  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (!value.length) {
      callback(new Error('请输入密码'));
    } else {
      callback();
    }
  };

  private loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }],
    captcha: [{ required: true, message: '请填写验证码', trigger: 'blur' }],
  };

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    const query = route.query as Dictionary<string>;
    if (query) {
      this.redirect = query.redirect;
    }
  }

  private showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = '';
    } else {
      this.passwordType = 'password';
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus();
    });
  }

  private handleLogin() {
    (this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await UserModule.Login(this.loginForm);
        if (!UserModule.token) {
          this.loading = false;
          this.getOmcCaptcha();
        }
      } else {
        return false;
      }
    });
  }

  async getOmcCaptcha() {
    try {
      const res = await getCaptcha();
      if (res) {
        this.url = res.data.captcha;
        this.loginForm.tid = res.data.tid;
      }
    } catch (error) {
      console.log('验证码', error);
    }
  }

  mounted() {
    this.getOmcCaptcha();
    if (this.loginForm.username === '') {
      (this.$refs.username as Input).focus();
    } else if (this.loginForm.password === '') {
      (this.$refs.password as Input).focus();
    } else if (this.loginForm.captcha === '') {
      (this.$refs.captcha as Input).focus();
    }
  }
}
